module.exports = __webpack_public_path__ + "img/banner1.8f132a51.jpg";